import * as React from "react";
import {
  Box,
  ButtonBase,
  Collapse,
  Grid,
  Typography,
  useMediaQuery,
  BoxProps,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import * as styles from "./styles.scss";
import { themeVariables } from "..";

interface IProps extends BoxProps {
  head?: any;
  collapseIn: boolean;
  children?: any;
}

export const FormSettingsInfo = ({
  head,
  collapseIn,
  children,
  ...boxProps
}: IProps) => {
  const theme = useTheme();

  return (
    <Collapse in={collapseIn} className={styles.rowInfo}>
      <Box
        borderTop={themeVariables.border}
        borderBottom={themeVariables.border}
        bgcolor={themeVariables.palette.grey["A100"]}
        className={styles.row}
        {...boxProps}
      >
        {children}
      </Box>
    </Collapse>
  );
};
